import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  Validators,
  FormGroup,
} from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';
import { BookingService } from 'src/app/services/booking.service';
import { Router } from '@angular/router';
import { EventType } from 'src/enum/eventtype';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';

@Component({
  selector: 'app-eefarmerbookingpopup',
  templateUrl: './eefarmerbookingpopup.component.html',
  styleUrls: ['./eefarmerbookingpopup.component.scss']
})
export class EefarmerbookingpopupComponent implements OnInit {
  showNotes: boolean = true;
  form: FormGroup;
  sentbackform:FormGroup;
  id: any;
  public eventEnum = EventType;
  public roleEnum=RoleType
  isDisabled: boolean = false;
  loading:boolean = true;
  sendBackDisabled: boolean = false;
  roleid: number;
  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private router: Router,
    public dialogRef: MatDialogRef<EefarmerbookingpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    private bookingService: BookingService,
    public addServiceDialog: MatDialog,
    private userSessionService:UserSessionService
  ) {
    this.id = this.dataRecievedData
    this.roleid=this.userSessionService.roleId()
  }


  ngOnInit(): void {
    this.showNotes = true;
    this.initializeValidators();
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      remarks: [null, Validators.required]
    })
    this.sentbackform = this.formBuilder.group({
      sendbackremarks: [null, Validators.required]
    })
  }


  next(isProceed) {
    this.dialogRef.close(isProceed);

  }
  sendbackcancel(isProceed) {
    this.dialogRef.close(isProceed);

  }
 
  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  goToAction() {
    this.isDisabled = true;
    this.loading = true;
    if (this.form.valid) {
      let request = {
        id: this.id.sessionId,
        eventType: this.eventEnum.EEApproval ,
        approvedStatusType: 1,
        remarks: this.form.value.remarks,
      };
      this.bookingService
        .approvalmanufacturerapproval(request)
        .subscribe((res) => {
          if (res && res.isSuccess) {
            this.isDisabled = false;
            this.loading = false;
            this.alertService.success('Successfully Approved the farmer Subsidy');
            this.dialogRef.close();
            this.router.navigate(['/eefarmerbookingapproval'])
            
          }
          else {
            this.isDisabled = false;
            this.loading = false;
            this.alertService.error(res.htmlFormattedFailures);
          }
      
        });
    } else {
      this.isDisabled = false;
      this.loading = false;
      this.validateFormControl()
    }
  }

  validateFormControlsremarks() {
    Object.keys(this.sentbackform.controls).forEach((field) => {
      const control = this.sentbackform.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  sendbackremarks(){
    this.sendBackDisabled = true;
    this.loading = true;
    if (this.sentbackform.valid) {
      let request = {
        id: this.id.sessionId,
        eventType:this.eventEnum.AEESendBack,
        remarks: this.sentbackform.value.sendbackremarks,
      };
      this.bookingService
        .sendBack(request)
        .subscribe((res) => {
          if (res) {
            this.sendBackDisabled = false;
            this.loading = false;
            this.alertService.success(this.roleid==this.roleEnum.AssistantExecutiveEngineer?'AEE Send Back Successfully':this.roleid==this.roleEnum.HortiJDHorDDH?'JDH Send Back Successfully':this.roleid==this.roleEnum.AgriJDA?'ADH Send Back Successfully':'');
            this.dialogRef.close();
            this.router.navigate(['/aefarmerbooking'])
          }
          else {
            this.sendBackDisabled = false;
            this.loading = false;
            // this.alertService.error(res.htmlFormattedFailures);
          }
        });
    } else {
      this.sendBackDisabled = false;
      this.loading = false;
      this.validateFormControlsremarks()
    }
  }
}
